import apiClient from "../apiClient";
import axios from "axios";

const offerService = {
  // Get all offers
  getOffers: async (params = {}) => {
    try {
      
      
      
      
      

      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.status) queryParams.append("status", params.status);
      if (params.search && params.search.trim()) queryParams.append("search", params.search.trim());
      if (params.fromDate) queryParams.append("fromDate", params.fromDate);
      if (params.toDate) queryParams.append("toDate", params.toDate);

      const url = `/recruitment/offers${queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;
      

      const response = await apiClient.get(url);
      
      
      
      
      
      
      
      
      

      return response.data;
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to fetch offers",
        error: error.response?.data?.error || error.message,
        data: null,
      };
    }
  },

  // Get offer stats
  getOfferStats: async () => {
    try {
      const response = await apiClient.get("/recruitment/offers/stats/kpi");
      return response;
    } catch (error) {
      
      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage: error.message,
        data: null,
      };
    }
  },

  // Get eligible candidates (completed interviews without offers)
  getEligibleCandidates: async (params = {}) => {
    try {
      
      const queryParams = new URLSearchParams();
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.search && params.search.trim()) {
        queryParams.append("search", params.search.trim());
      }

      const url = `/recruitment/offers/eligible-candidates${queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;
      

      const response = await apiClient.get(url);
      
      
      
      

      // Standardize response (return candidates array)
      if (Array.isArray(response?.candidates)) {
        return response.candidates;
      }
      if (Array.isArray(response?.data?.candidates)) {
        return response.data.candidates;
      }

      return [];
    } catch (error) {
      
      return [];
    }
  },

  // Get offer by ID
  getOfferById: async (id) => {
    try {
      
      
      
      
      

      const response = await apiClient.get(`/recruitment/offers/${id}`);
      
      
      
      
      
      
      

      return response.data;
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to fetch offer",
        error: error.response?.data?.error || error.message,
        data: null,
      };
    }
  },

  // Create offer
  createOffer: async (offerData) => {
    try {
      
      
      
      
      

      // Use apiClient which uses environment variable for base URL
      // Note: apiClient interceptor returns response.data directly, so 'response' is already the data object
      const responseData = await apiClient.post("/recruitment/offers", offerData);

      
      
      
      
      

      // The apiClient interceptor already extracts response.data, so responseData IS the data object
      // Ensure it has the proper structure
      if (!responseData.responseCode && responseData.status) {
        responseData.responseCode = responseData.status;
      }

      // If response doesn't have responseMessage but has responseCode 201, add default message
      if (!responseData.responseMessage && responseData.responseCode === 201) {
        responseData.responseMessage = "Offer created successfully";
      }

      return responseData;
    } catch (error) {
      
      
      

      // The apiClient interceptor throws errors, so we catch them here
      // Re-throw to let React Query handle it
      throw error;
    }
  },

  // Update offer
  updateOffer: async (id, offerData) => {
    try {
      
      
      
      
      

      const response = await apiClient.put(
        `/recruitment/offers/${id}`,
        offerData
      );
      
      
      
      
      
      
      
      
      
      

      // Ensure consistent response format
      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        // Wrap direct response in standard format
        return {
          responseCode: 200,
          responseMessage: "Offer updated successfully",
          data: response.data,
        };
      }
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to update offer",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Delete offer
  deleteOffer: async (id) => {
    try {
      
      
      
      
      

      const response = await apiClient.delete(`/recruitment/offers/${id}`);
      
      
      

      // Ensure we always return a proper response object
      if (response.data) {
        
        return response.data;
      } else {
        
        return {
          success: true,
          responseCode: response.status || 200,
          responseMessage: "Offer deleted successfully",
          data: null,
        };
      }
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to delete offer",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Send offer
  sendOffer: async (id) => {
    try {
      
      
      
      
      

      const response = await apiClient.post(`/recruitment/offers/${id}/send`);
      
      

      return response.data;
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to send offer",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Accept offer
  acceptOffer: async (id) => {
    try {
      
      
      
      
      

      const response = await apiClient.post(`/recruitment/offers/${id}/accept`);
      
      

      return response.data;
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to accept offer",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Reject offer
  rejectOffer: async (id) => {
    try {
      
      
      
      
      

      const response = await apiClient.post(`/recruitment/offers/${id}/reject`);
      
      

      return response.data;
    } catch (error) {
      
      
      

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to reject offer",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Send offer email to candidate
  sendOfferEmail: async (offerId, isResend = false) => {
    try {
      
      
      
      
      

      const url = `/recruitment/offers/${offerId}/send-email${isResend ? '?resend=true' : ''}`;
      const response = await apiClient.post(url);

      
      
      

      // Check if response.data has the expected structure
      if (response.data && response.data.responseCode) {
        
        return response.data;
      } else {
        
        return {
          responseCode: 200,
          responseMessage: "Offer email sent successfully",
          data: response.data,
          success: true,
        };
      }
    } catch (error) {
      
      
      

      // Throw error so React Query mutation can handle it
      const errorResponse = {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to send offer email",
        error: error.response?.data?.error || error.message,
      };

      // Create a new Error with the response message for React Query to catch
      const errorObj = new Error(errorResponse.responseMessage);
      errorObj.response = errorResponse;
      throw errorObj;
    }
  },

  // Upload documents
  uploadDocuments: async (formData) => {
    try {
      
      
      
      
      
      
      
      
      

      const response = await apiClient.post(
        "/recruitment/offers/upload-documents",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      
      return response;
    } catch (error) {
      
      
      

      throw new Error(
        error.response?.data?.responseMessage ||
        error.message ||
        "Failed to upload documents"
      );
    }
  },
};

export default offerService;
